module.exports = __webpack_public_path__ + "img/main-active.6ac60df6.png";